import React, { useState } from 'react';
import { IconEye, IconEyeOff, IconMail, IconLock, IconUser, IconArrowLeft } from '@tabler/icons-react';
interface RegisterPageProps {
  onRegister: () => void;
  onSwitchToLogin: () => void;
  onBack?: () => void;
}
export function RegisterPage({
  onRegister,
  onSwitchToLogin,
  onBack
}: RegisterPageProps) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert('Le password non coincidono');
      return;
    }
    if (!acceptTerms) {
      alert('Devi accettare i termini e condizioni');
      return;
    }
    console.log('Register:', {
      name,
      email,
      password
    });
    onRegister();
  };
  const passwordStrength = (password: string) => {
    if (password.length === 0) return {
      strength: 0,
      label: '',
      color: ''
    };
    if (password.length < 6) return {
      strength: 1,
      label: 'Debole',
      color: '#FAD88A'
    };
    if (password.length < 10) return {
      strength: 2,
      label: 'Media',
      color: '#AEDAFF'
    };
    return {
      strength: 3,
      label: 'Forte',
      color: '#B0EC9C'
    };
  };
  const strength = passwordStrength(password);
  return <div className="flex flex-col min-h-screen bg-yeppy-bg" data-id="element-1124">
      {/* Header - Standard navbar */}
      {onBack && <div className="px-4 pt-4 pb-3" data-id="element-1125">
          <div className="flex items-center gap-3 mb-3" data-id="element-1126">
            <button onClick={onBack} className="flex items-center justify-center w-10 h-10 bg-white border border-yeppy-text border-opacity-15 rounded-full transition-colors flex-shrink-0" aria-label="Indietro" data-id="element-1127">
              <IconArrowLeft className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-1128" />
            </button>
          </div>
        </div>}

      {/* Content */}
      <div className={`flex-1 overflow-y-auto px-4 py-6 ${!onBack ? 'pt-6' : ''}`} data-id="element-1129">
        <div className="w-full max-w-md mx-auto" data-id="element-1130">
          {/* Logo */}

          {/* Register Card */}
          <div className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-6 mb-4" data-id="element-1131">
            <h2 className="font-rubik text-lg text-yeppy-text mb-2 text-center font-[500]" data-id="element-1132">
              Crea il tuo account
            </h2>
            <p className="font-poppins text-sm text-yeppy-text text-opacity-60 mb-6 text-center" data-id="element-1133">
              Inizia a organizzare la tua vita familiare
            </p>

            <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1134">
              {/* Name */}
              <div data-id="element-1135">
                <label htmlFor="name" className="block font-poppins text-sm font-medium text-yeppy-text mb-2" data-id="element-1136">
                  Nome completo
                </label>
                <div className="relative" data-id="element-1137">
                  <IconUser className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1138" />
                  <input id="name" type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Mario Rossi" className="w-full pl-12 pr-4 py-3 rounded-xl font-poppins text-sm text-yeppy-text bg-white border border-yeppy-text border-opacity-15 focus:outline-none focus:border-yeppy-blue focus:border-opacity-50 transition-colors placeholder-yeppy-text placeholder-opacity-40" required data-id="element-1139" />
                </div>
              </div>

              {/* Email */}
              <div data-id="element-1140">
                <label htmlFor="email" className="block font-poppins text-sm font-medium text-yeppy-text mb-2" data-id="element-1141">
                  Email
                </label>
                <div className="relative" data-id="element-1142">
                  <IconMail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1143" />
                  <input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="mario.rossi@email.com" className="w-full pl-12 pr-4 py-3 rounded-xl font-poppins text-sm text-yeppy-text bg-white border border-yeppy-text border-opacity-15 focus:outline-none focus:border-yeppy-blue focus:border-opacity-50 transition-colors placeholder-yeppy-text placeholder-opacity-40" required data-id="element-1144" />
                </div>
              </div>

              {/* Password */}
              <div data-id="element-1145">
                <label htmlFor="password" className="block font-poppins text-sm font-medium text-yeppy-text mb-2" data-id="element-1146">
                  Password
                </label>
                <div className="relative" data-id="element-1147">
                  <IconLock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1148" />
                  <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="w-full pl-12 pr-12 py-3 rounded-xl font-poppins text-sm text-yeppy-text bg-white border border-yeppy-text border-opacity-15 focus:outline-none focus:border-yeppy-blue focus:border-opacity-50 transition-colors placeholder-yeppy-text placeholder-opacity-40" required data-id="element-1149" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-1/2 -translate-y-1/2" data-id="element-1150">
                    {showPassword ? <IconEyeOff className="w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1151" /> : <IconEye className="w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1152" />}
                  </button>
                </div>
                {password && <div className="mt-2" data-id="element-1153">
                    <div className="flex items-center gap-2 mb-1" data-id="element-1154">
                      <div className="flex-1 h-1.5 bg-yeppy-bg rounded-full overflow-hidden" data-id="element-1155">
                        <div className="h-full rounded-full transition-all duration-300" style={{
                      width: `${strength.strength / 3 * 100}%`,
                      backgroundColor: strength.color
                    }} data-id="element-1156" />
                      </div>
                      <span className="font-poppins text-xs font-medium" style={{
                    color: strength.color
                  }} data-id="element-1157">
                        {strength.label}
                      </span>
                    </div>
                    <p className="font-poppins text-xs text-yeppy-text text-opacity-60" data-id="element-1158">
                      Minimo 8 caratteri
                    </p>
                  </div>}
              </div>

              {/* Confirm Password */}
              <div data-id="element-1159">
                <label htmlFor="confirmPassword" className="block font-poppins text-sm font-medium text-yeppy-text mb-2" data-id="element-1160">
                  Conferma password
                </label>
                <div className="relative" data-id="element-1161">
                  <IconLock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1162" />
                  <input id="confirmPassword" type={showConfirmPassword ? 'text' : 'password'} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="••••••••" className="w-full pl-12 pr-12 py-3 rounded-xl font-poppins text-sm text-yeppy-text bg-white border border-yeppy-text border-opacity-15 focus:outline-none focus:border-yeppy-blue focus:border-opacity-50 transition-colors placeholder-yeppy-text placeholder-opacity-40" required data-id="element-1163" />
                  <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="absolute right-4 top-1/2 -translate-y-1/2" data-id="element-1164">
                    {showConfirmPassword ? <IconEyeOff className="w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1165" /> : <IconEye className="w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1166" />}
                  </button>
                </div>
                {confirmPassword && password !== confirmPassword && <p className="mt-2 font-poppins text-xs text-yeppy-text text-opacity-60" data-id="element-1167">
                    Le password non coincidono
                  </p>}
              </div>

              {/* Terms and Conditions */}
              <div data-id="element-1168">
                <label className="flex items-start gap-2 cursor-pointer" data-id="element-1169">
                  <input type="checkbox" checked={acceptTerms} onChange={e => setAcceptTerms(e.target.checked)} className="mt-0.5 w-4 h-4 rounded border-2 border-yeppy-text border-opacity-20 text-yeppy-blue focus:ring-2 focus:ring-yeppy-blue focus:ring-opacity-30" required data-id="element-1170" />
                  <span className="font-poppins text-sm text-yeppy-text text-opacity-70" data-id="element-1171">
                    Accetto i{' '}
                    <button type="button" className="text-yeppy-text transition-opacity" data-id="element-1172">
                      termini e condizioni
                    </button>{' '}
                    e la{' '}
                    <button type="button" className="text-yeppy-text transition-opacity" data-id="element-1173">
                      privacy policy
                    </button>
                  </span>
                </label>
              </div>

              {/* Register Button */}
              <button type="submit" className="w-full py-3 rounded-xl font-poppins text-sm font-semibold transition-colors" style={{
              backgroundColor: '#1D2A36',
              color: '#FFFFFB'
            }} data-id="element-1174">
                Registrati
              </button>
            </form>
          </div>

          {/* Login Link */}
          <div className="text-center" data-id="element-1175">
            <p className="font-poppins text-sm text-yeppy-text text-opacity-60" data-id="element-1176">
              Hai già un account?{' '}
              <button onClick={onSwitchToLogin} className="font-semibold text-yeppy-text transition-opacity" data-id="element-1177">
                Accedi
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>;
}